function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 22H2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18.5c.41 0 .75.34.75.75s-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.59 13.7l-7.23 7.23a3.618 3.618 0 01-5.12.01l-4.61-4.61L15.99 3.97l4.61 4.61a3.618 3.618 0 01-.01 5.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.99 3.97L3.62 16.33l-.91-.91a3.618 3.618 0 01.01-5.12l7.23-7.23a3.618 3.618 0 015.12-.01l.92.91zm-3.1 13.63l-1.35 1.35c-.28.28-.73.28-1.01 0a.712.712 0 010-1.01l1.35-1.35c.28-.28.73-.28 1.01 0s.28.73 0 1.01zm4.38-4.38l-2.69 2.69c-.28.28-.73.28-1.01 0a.712.712 0 010-1.01l2.69-2.69c.28-.28.73-.28 1.01 0 .27.28.27.73 0 1.01z"
})));